var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLista(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7778 2H4.21111C2.97778 2 2.01111 2.98889 2.01111 4.22222L2 19.7778C2 21 2.97778 22 4.21111 22H19.7778C21 22 22 21 22 19.7778V4.22222C22 2.98889 21 2 19.7778 2ZM19.7778 15.3333H15.3333C15.3333 17.1778 13.8333 18.6667 12 18.6667C10.1667 18.6667 8.66667 17.1778 8.66667 15.3333H4.21111V4.22222H19.7778V15.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLista);
export default __webpack_public_path__ + "static/media/lista.557d3a04ede0e167b9e999133f25f592.svg";
export { ForwardRef as ReactComponent };